import { Table } from '@tanstack/react-table';

import { Input } from '@/components/ui/input';

import { TableViewOptions } from './TableViewOptions';

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
  // Still accepted by callers; only consumed by the disabled AddSubAdminDialog below.
  refetchData: () => void;
}

export function TableToolbar<TData>({ table }: DataTableToolbarProps<TData>) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-x-2">
        <TableViewOptions table={table} />
        <div className="flex flex-1 items-center space-x-2">
          <Input
            placeholder="Search...."
            value={
              (table.getColumn('emailid')?.getFilterValue() as string) ?? ''
            }
            onChange={(event) =>
              table.getColumn('emailid')?.setFilterValue(event.target.value)
            }
            className="h-8 w-[150px] lg:w-[250px]"
          />
        </div>
      </div>
      {/* To restore: re-import AddSubAdminDialog from './AddSubAdminDialog',
          destructure refetchData above, and render
          <AddSubAdminDialog refetchData={refetchData} /> */}
    </div>
  );
}
